import { render, staticRenderFns } from "./ui-accordion-item.vue?vue&type=template&id=09919ae9&"
import script from "./ui-accordion-item.vue?vue&type=script&lang=js&"
export * from "./ui-accordion-item.vue?vue&type=script&lang=js&"
import style0 from "./ui-accordion-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09919ae9')) {
      api.createRecord('09919ae9', component.options)
    } else {
      api.reload('09919ae9', component.options)
    }
    module.hot.accept("./ui-accordion-item.vue?vue&type=template&id=09919ae9&", function () {
      api.rerender('09919ae9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-accordion/ui-accordion-item.vue"
export default component.exports